import React from "react";
import { Modal, Avatar, Button, Tooltip } from "antd";
import {
  // LockOutlined,
  // SecurityScanOutlined,
  // QuestionCircleOutlined,
  LogoutOutlined,
  // ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./modalstyles.css"; // Import your custom CSS file
// import { REDIRECT_PROFILE } from "../../../config";
import { useNavigate } from "react-router-dom";
import { helpPage } from "./HelpPageRedirect";

function ModalTesting({ visible, handleClose, userInfo }) {
  const currentUrl = window.location.href;
  //console.log(currentUrl);
  //console.log(userInfo.profile_pic);
  const firstLetter = userInfo?.first_name
    ? userInfo.first_name[0].toUpperCase()
    : "";

  const menu_options = userInfo?.profile_info?.profile_links;
  // console.log(menu_options);
  const history = useNavigate();
  const handleCancel = () => {
    handleClose();
  };

  const navigateHomePage = () => {
    // history("/home");
    window.open(helpPage(currentUrl), "_blank");
  };

  //console.log(userInfo);
  // const display_role = userInfo?.is_superadmin ? "TN Admin" : "Client Admin";
  const handleMenuClick = (option) => {
    // Special handling for Help Page
    if (option.display_name === "Help Page") {
      navigateHomePage();
      return;
    }

    // The production base URL for this app
    const productionBaseUrl = "https://testapps.trainery.one";

    // Handle navigation logic
    if (option.url) {
      // If running locally and the URL is for production, use history for SPA navigation
      if (
        window.location.hostname === "localhost" &&
        option.url.startsWith(productionBaseUrl)
      ) {
        const relativePath = option.url.replace(productionBaseUrl, "");
        history(relativePath);
      }
      // If the URL matches the current origin, use history for SPA navigation
      else if (option.url.startsWith(window.location.origin)) {
        const relativePath = option.url.replace(window.location.origin, "");
        history(relativePath);
      }
      // Otherwise, navigate using a full page reload
      else {
        // If Sign Out or Impersonate, clear local storage before redirecting
        if (
          option.display_name === "Sign Out" ||
          option.display_name.toLowerCase().includes("impersonate")
        ) {
          localStorage.clear();
        }
        window.location.href = option.url;
      }
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      style={{
        position: "fixed",
        top: "45px",
        right: "10px",
        left: "auto",
        bottom: "auto",
        transform: "none",
      }}
      title={
        <p
          style={{
            fontFamily: "Poppins",
            color: "#203864",
            textTransform: "capitalize",
          }}
        >
          {userInfo?.first_name} {userInfo?.last_name}
        </p>
      }
      width={320}
    >
      <div className="user-profile">
        <div className="user-info">
          <p style={{ marginTop: "2.5px" }}>User ID: {userInfo?.user_id}</p>
          <Tooltip title={userInfo?.email}>
            <p
              style={{
                maxWidth: "170px",
                textDecoration: "underline",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {userInfo?.email}
            </p>
          </Tooltip>
        </div>
        {userInfo.profile_pic ? (
          <>
            <Avatar size={52.5} src={userInfo?.profile_pic} />
          </>
        ) : (
          <>
            <Avatar
              size={52.5}
              style={{
                backgroundColor: "#b3cee5",
                color: "#0000B9",
                marginRight: "10px",
                fontSize: "28px",
                fontFamily: "Poppins",
              }}
            >
              {firstLetter}
            </Avatar>
          </>
        )}
      </div>

      <div className="modal-options">
        {Array.isArray(menu_options) && menu_options.length > 0 ? (
          menu_options.map((opt) =>
            opt.type === "Button" ? (
              <Button
                danger
                type="primary"
                key={opt.display_name}
                onClick={() => handleMenuClick(opt)}
                style={{ width: "80%" }}
              >
                <img src={opt.logo} alt={""} className="modal-icon-styles" />{" "}
                {opt.display_name}
              </Button>
            ) : (
              <div
                className="option"
                key={opt.display_name}
                onClick={() => handleMenuClick(opt)}
              >
                <p>
                  <img src={opt.logo} alt={""} className="modal-icon-styles" />{" "}
                  {opt.display_name}
                </p>
              </div>
            )
          )
        ) : (
          // this case is written if for some reason there is failure in auth-res
          <Button
            danger
            type="primary"
            className="sign-out-style"
            key="default-logout"
            style={{ width: "80%" }}
            onClick={() =>
              (window.location.href = "https://testapps.trainery.one/logout")
            }
          >
            <LogoutOutlined style={{ fontSize: "15px" }} /> Sign Out
          </Button>
        )}
      </div>
    </Modal>
  );
}

export default ModalTesting;
